export const allOtas = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "booklogic", "simplotel","easemytrip"];
export const otasExceptBooklogic = ["bookingdotcom", "agoda", "goibibo", "yatra", "expedia", "simplotel","easemytrip"];
